import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import Constants from "../business/Constants";
import PromoApi from "mbpromo/src/api/PromoApi";
import Pristine from "pristinejs/dist/pristine";

class AssociaNumeroCtrl extends SmartComponent {
	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		this.init();
		this.userPrivacyProfiling = false;
		this.promoApi = new PromoApi({promoCode: Constants.API_PROMOCODE});
		this.pristine;
	}

	init() {
		this.loadChildComponents(this);
		this.startLoader();

		GigyaManager.getLoggedUserCached().then((u) => {
			let form = document.getElementById("template-form");


			let formConfig = {
				// class of the parent element where the error/success class is added
				classTo: 'col-form',
				errorClass: 'error',
				successClass: 'has-success',
				// class of the parent element where error text element is appended
				errorTextParent: 'col-form',
				// type of element to create for the error text
				errorTextTag: 'span',
				// class of the error text element
				errorTextClass: 'error-field'
			};

			this.userPrivacyProfiling = u.preferences.privacy_profiling.isConsentGranted;
			const ch = u.data[Constants.CH_PROMO];
			if(typeof ch !== "undefined" && ch !== null && ch !== ""){
				$('#regulationAcceptance').remove();
			}

			this.trimRequired();

			// init form validator
			this.pristine = new Pristine(form, formConfig);

			this.promoApi.areaPersonale().then((data) => {
				const body = data.body;
				const winCodes = body.response.data.receipts.filter(c =>  c.status === "WIN");

				if(winCodes.length === 2){
					let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Hai già vinto entrambi i premi, non puoi associare il numero di telefono!</h2>
                                                            <a href="/promozioni/promocolazione2022/area-personale" class="button">Torna all’area personale</a>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
					$(this.element).append(tmplModalGeneric);
					this.loadChildComponents(this);
				}

				this.removeLoader();
			}, ()=>{
				this.removeLoader()
			})
		}, () => {
			window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
		})
	}

	submitForm(){
		if(!$('#conferma').prop("disabled")){
			$('#conferma').prop("disabled", true);
			/*
			$('.error-feedback').remove();
			$('input, select').removeClass('error');*/

			let validateForm = this.pristine.validate();
			if(validateForm){
				var telefono = $('#telefono').val();
				if( $('#acceptance').length ) {
					this.startLoader();
					GigyaManager.addCH(Constants.CH_PROMO).then(() => {
						this.doTelephoneAssociationCall(telefono, true);
					}, () => {
						let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>Ti preghiamo di riprovare più tardi!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
						$(this.element).append(tmplModalGeneric);
						this.loadChildComponents(this);
						$('#conferma').prop("disabled", false);
						this.removeLoader();
					})
				} else{
					this.startLoader();
					this.doTelephoneAssociationCall(telefono);
				}
			}else{
				this.scrollToError();
				$('#conferma').prop("disabled", false);
			}
		}
	}

	doTelephoneAssociationCall(telephone, flagCH){
		this.promoApi.associaTelefono("39"+telephone, this.userPrivacyProfiling).then((resp)=>{
			window.location.href='/promozioni/promocolazione2022/hai-vinto?pt='+resp.body.response.data.play_token+"&pm=3";
		}, (resp)=>{
			let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>${resp.body.status.errors.data.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
			if(flagCH){
				GigyaManager.removeCH(Constants.CH_PROMO);
			}
			$(this.element).append(tmplModalGeneric);
			this.loadChildComponents(this);
			$('#conferma').prop("disabled", false);
			this.removeLoader();
		});
	}

	removeLoader(){
		$('.tool_loader').fadeOut(500).remove();
		$('body').removeClass('noScroll');
	}

	startLoader(){
		$('.mb-promo').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
		$('body').addClass('noScroll');
	}

	/**
	 * Trim all required fields
	 */
	trimRequired(){
		Pristine.addValidator('required', (value) => {
			return ( value.trim() !== '' );
		}, "", 5, false);
	}

	/**
	 * Scroll to error
	 */
	scrollToError(){
		$([document.documentElement, document.body]).animate({
			scrollTop: $(".error").offset().top - 25
		}, 1500);
	}

}
export default AssociaNumeroCtrl;
